import { lazyNamed } from 'src/utils/lazyNamed';

const AdsConfigV2 = {
  ConfigsList: lazyNamed(() => import('./containers/ConfigsList'), 'ConfigsList'),
  BlocksList: lazyNamed(() => import('./containers/BlocksList'), 'BlocksList'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
};

export default AdsConfigV2;
